import React from "react";
import Navigation from "./Navigation";
import Footer from "./Footer";

function BookADemo() {
    return (
        <div>
            <div className="banner-section-outer">
                <Navigation/>
                <section className="sub-banner-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 text-center">
                                <div className="sub-banner-text">
                                    <h1 className="text-white mb-lg-4 mb-3">Get a Free Quote</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <section class="customer-base-section about-page-customer-base-section contact-form-section my-5">
                <div class="container">
                    <div class=" order-xl-1 order-lg-1 order-md-1 order-sm-2 order-2 text-md-left text-center">
                        <div class="customer-base-section-text position-relative text-center">
                            <h2 class="mb-lg-4 mb-md-3 mb-2">
                                Customer Experience just reached new heights!
                            </h2>
                            <p>
                                Your email address will not be published. Required fields are
                                marked *
                            </p>
                            <div class="contact-form">
                                <form method="POST" action="contact-form.php">
                                    <div className="row">
                                        <div className="col-6">
                                            {" "}
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="First Name:"
                                                    name="name"
                                                    id="name"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            {" "}
                                            <div class="form-group">
                                                <input
                                                    type="email"
                                                    class="form-control"
                                                    placeholder="Last Name:"
                                                    name="email"
                                                    id="email"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            {" "}
                                            <div class="form-group">
                                                <input
                                                    type="email"
                                                    class="form-control"
                                                    placeholder="Your Email:"
                                                    name="email"
                                                    id="email"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            {" "}
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Phone Number:"
                                                    name="name"
                                                    id="name"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            {" "}
                                            <div class="form-group">
                                                <input
                                                    type="email"
                                                    class="form-control"
                                                    placeholder="Company:"
                                                    name="email"
                                                    id="email"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <textarea
                                            class="form-control textarea"
                                            placeholder="Add Comment:"
                                            rows="3"
                                            name="comments"
                                            id="comments"
                                        ></textarea>
                                    </div>
                                    <div class="submitform-button">
                                        <button
                                            type="submit"
                                            id="submit"
                                            class="submitform-btn hover-effect d-block"
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer/>
        </div>
    );
}

export default BookADemo;
